module.exports = __webpack_public_path__ + "static/media/resposta-longa-icon.87499527.svg";